import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { BidPackage, BidPackageLineItem, BidPackageParams } from './types';

export const GET_BID_PACKAGE_LIST = 'bidPackages/GET_BID_PACKAGE_LIST';
export const GET_BID_PACKAGE_LIST_SUCCESS =
  'bidPackages/GET_BID_PACKAGE_LIST_SUCCESS';
export const GET_BID_PACKAGE_LIST_ERROR =
  'bidPackages/GET_BID_PACKAGE_LIST_ERROR';

export const CREATE_BID_PACKAGE = 'bidPackages/CREATE_BID_PACKAGE';
export const CREATE_BID_PACKAGE_SUCCESS =
  'bidPackages/CREATE_BID_PACKAGE_SUCCESS';
export const CREATE_BID_PACKAGE_ERROR = 'bidPackages/CREATE_BID_PACKAGE_ERROR';

export const UPDATE_BID_PACKAGE = 'bidPackages/UPDATE_BID_PACKAGE';
export const UPDATE_BID_PACKAGE_SUCCESS =
  'bidPackages/UPDATE_BID_PACKAGE_SUCCESS';
export const UPDATE_BID_PACKAGE_ERROR = 'bidPackages/UPDATE_BID_PACKAGE_ERROR';

export const DELETE_BID_PACKAGE = 'bidPackages/DELETE_BID_PACKAGE';
export const DELETE_BID_PACKAGE_SUCCESS =
  'bidPackages/DELETE_BID_PACKAGE_SUCCESS';
export const DELETE_BID_PACKAGE_ERROR = 'bidPackages/DELETE_BID_PACKAGE_ERROR';

export const GET_BID_PACKAGE_DETAIL = 'bidPackages/GET_BID_PACKAGE_DETAIL';
export const GET_BID_PACKAGE_DETAIL_SUCCESS =
  'bidPackages/GET_BID_PACKAGE_DETAIL_SUCCESS';
export const GET_BID_PACKAGE_DETAIL_ERROR =
  'bidPackages/GET_BID_PACKAGE_DETAIL_ERROR';

// export const CREATE_BID_PACKAGE_LINE_ITEM =
//   'bidPackages/CREATE_BID_PACKAGE_LINE_ITEM';
// export const CREATE_BID_PACKAGE_LINE_ITEM_SUCCESS =
//   'bidPackages/CREATE_BID_PACKAGE_LINE_ITEM_SUCCESS';
// export const CREATE_BID_PACKAGE_LINE_ITEM_ERROR =
//   'bidPackages/CREATE_BID_PACKAGE_LINE_ITEM_ERROR';

// export const DELETE_BID_PACKAGE_LINE_ITEM =
//   'bidPackages/DELETE_BID_PACKAGE_LINE_ITEM';
// export const DELETE_BID_PACKAGE_LINE_ITEM_SUCCESS =
//   'bidPackages/DELETE_BID_PACKAGE_LINE_ITEM_SUCCESS';
// export const DELETE_BID_PACKAGE_LINE_ITEM_ERROR =
//   'bidPackages/DELETE_BID_PACKAGE_LINE_ITEM_ERROR';

export const CREATE_EMPTY_BID_PACKAGE_LINE_ITEM =
  'bidPackages/CREATE_EMPTY_BID_PACKAGE_LINE_ITEM';
export const CREATE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS =
  'bidPackages/CREATE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS';
export const CREATE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR =
  'bidPackages/CREATE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR';

export const UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM =
  'bidPackages/UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM';
export const UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS =
  'bidPackages/UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS';
export const UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR =
  'bidPackages/UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR';

export const DELETE_EMPTY_BID_PACKAGE_LINE_ITEM =
  'bidPackages/DELETE_EMPTY_BID_PACKAGE_LINE_ITEM';
export const DELETE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS =
  'bidPackages/DELETE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS';
export const DELETE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR =
  'bidPackages/DELETE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR';

export const getBidPackageListAsync = createAsyncAction(
  GET_BID_PACKAGE_LIST,
  GET_BID_PACKAGE_LIST_SUCCESS,
  GET_BID_PACKAGE_LIST_ERROR,
)<BidPackageParams, BidPackage[], AxiosError>();

export const createBidPackageAsync = createAsyncAction(
  CREATE_BID_PACKAGE,
  CREATE_BID_PACKAGE_SUCCESS,
  CREATE_BID_PACKAGE_ERROR,
)<BidPackageParams, BidPackage, AxiosError>();

export const updateBidPackageAsync = createAsyncAction(
  UPDATE_BID_PACKAGE,
  UPDATE_BID_PACKAGE_SUCCESS,
  UPDATE_BID_PACKAGE_ERROR,
)<BidPackageParams, BidPackage, AxiosError>();

export const deleteBidPackageAsync = createAsyncAction(
  DELETE_BID_PACKAGE,
  DELETE_BID_PACKAGE_SUCCESS,
  DELETE_BID_PACKAGE_ERROR,
)<BidPackageParams, number, AxiosError>();

export const getBidPackageDetailAsync = createAsyncAction(
  GET_BID_PACKAGE_DETAIL,
  GET_BID_PACKAGE_DETAIL_SUCCESS,
  GET_BID_PACKAGE_DETAIL_ERROR,
)<BidPackageParams, BidPackage, AxiosError>();

// export const createBidPackageLineItemAsync = createAsyncAction(
//   CREATE_BID_PACKAGE_LINE_ITEM,
//   CREATE_BID_PACKAGE_LINE_ITEM_SUCCESS,
//   CREATE_BID_PACKAGE_LINE_ITEM_ERROR,
// )<BidPackageParams, BidPackageLineItem, AxiosError>();

// export const deleteBidPackageLineItemAsync = createAsyncAction(
//   DELETE_BID_PACKAGE_LINE_ITEM,
//   DELETE_BID_PACKAGE_LINE_ITEM_SUCCESS,
//   DELETE_BID_PACKAGE_LINE_ITEM_ERROR,
// )<BidPackageParams, number, AxiosError>();

export const createEmptyBidPackageLineItemAsync = createAsyncAction(
  CREATE_EMPTY_BID_PACKAGE_LINE_ITEM,
  CREATE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS,
  CREATE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR,
)<BidPackageParams, BidPackageLineItem[], AxiosError>();

export const updateEmptyBidPackageLineItemAsync = createAsyncAction(
  UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM,
  UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS,
  UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR,
)<BidPackageParams, BidPackageLineItem[], AxiosError>();

export const deleteEmptyBidPackageLineItemAsync = createAsyncAction(
  DELETE_EMPTY_BID_PACKAGE_LINE_ITEM,
  DELETE_EMPTY_BID_PACKAGE_LINE_ITEM_SUCCESS,
  DELETE_EMPTY_BID_PACKAGE_LINE_ITEM_ERROR,
)<BidPackageParams, null, AxiosError>();
